// Input attributes for the contact fields: the right keyboard on phones and
// browser autofill (iOS, Android, desktop) for name, email and postal code.
export const NAME_INPUT_PROPS = {
  autoComplete: "name",
  autoCapitalize: "words",
  autoCorrect: "off",
  spellCheck: false
};

export const EMAIL_INPUT_PROPS = {
  autoComplete: "email",
  autoCapitalize: "none",
  autoCorrect: "off",
  spellCheck: false
};

// type="number" shows the symbol keyboard on iOS and no autofill; a text
// field with inputMode="numeric" shows the digit keypad instead
export const POSTAL_CODE_INPUT_PROPS = {
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]*",
  autoComplete: "postal-code",
  name: "postalCode",
  "aria-label": "Postleitzahl"
};

// Keydown handler that runs `callback` on Enter instead of submitting the
// form, e.g. to jump to the next field as the keyboard's "Weiter" key says
export const onEnterKey = (callback) => (event) => {
  if (event.key !== "Enter" || event.nativeEvent?.isComposing) return;
  event.preventDefault();
  callback();
};
